import { Component, OnInit,AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { Options } from 'ngx-slider-v2';
import Utils from 'src/app/utils';
import * as _ from 'lodash-es';
declare var require: any;
declare var google: any;
declare var mapboxgl: any;
declare var turf: any;

@Component({
  selector: 'app-safetyzones-edit',
  templateUrl: './safetyzones-edit.component.html',
  styleUrls: ['./safetyzones-edit.component.scss']
})
export class SafetyzonesEditComponent implements OnInit {

  safety_zone:any;
  id?: number;

  formGroup:any;
  submitted = false;
  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  map:any;
  center:any;
  circle:any;
  marker:any;
  zoom = 12;
  //@ViewChild('myMap') myMap: ElementRef;

  // radius: number = 0;
  options: Options = {
    floor: 200,
    ceil: 5000,
    tickStep: 50,
  };

  workerFormGroup:any;
  submittedWF = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    this.id = +this.route.snapshot.params['id'];

    this.getSafetyZone();
  }

  getSafetyZone(){

    this.okService.get("safetyzones/"+this.id,{expand:'workers'})
    .subscribe((data) => {

      this.safety_zone = data.body;
      // this.radius = this.safety_zone.radius;

      console.log(this.safety_zone);

      this.setForm();

      this.setupMap();
    })

  }

  setForm(){

    this.formGroup = new FormGroup({
      name: new FormControl(this.safety_zone.name,[Validators.required]),
      description: new FormControl(this.safety_zone.description,[]),
      lat: new FormControl(this.safety_zone.lat,[]),
      lng: new FormControl(this.safety_zone.lng,[]),
      radius: new FormControl(this.safety_zone.radius,[])
    });

    this.workerFormGroup = new FormGroup({
      ids : new FormControl([],[]),
    });

  }

  submitForm(){

    if(this.submitted){
      Object.keys(this.formGroup.controls).forEach(key => {
        this.formGroup.get(key)?.setErrors({ invalid: null });
        this.formGroup.get(key)?.updateValueAndValidity();
      });
    }

    this.submitted = true;
    if (this.formGroup.valid) {
      let values = this.formGroup.value;

      values['lat'] = this.formGroup.value.lat;
      values['lng'] = this.formGroup.value.lng;
      values['radius'] = this.formGroup.value.radius;

      //console.log(values);
      this.okService.put("safetyzones/"+this.id,values)
      .subscribe({
        next: (data) => {
          this.getSafetyZone();

          //console.log('edited safety zone',this.safety_zone);
          this.okService.setAlert(this.transloco.translate("The safety zone has been updated"), "success");

        },
        error: (e) => {

          if(Array.isArray(e)){
            let self = this;
            // Use of _.forEach() method
            _.forEach(e, function(error:any) {
              //console.log(error);
              self.formGroup.get(error.field)?.setErrors({ invalid: error.message });
            });
          }else{
            this.okService.setAlert(e,"warning")
          }


        },
          complete: () => {
            //console.info('complete');
          }
    });
    }

    return false;

  }

  doDelete(){
    if(confirm(this.transloco.translate("Are you sure you want to delete ")+this.safety_zone.name)) {

      this.okService.delete("safetyzones/"+this.safety_zone.id)
      .subscribe((data) => {

        this.okService.setAlert(this.transloco.translate("The safety zone has been deleted"), "success");
        this.router.navigateByUrl('/mgmt/safetyzones');

      });
    }
  }

  setupMap(){

    mapboxgl.accessToken = 'pk.eyJ1IjoidHJ1c3R5b3giLCJhIjoiY2wxY2Y0emQ1MDcwOTNwcDNxYTd3ODB1ZyJ9.moSeRr49cY5d14hosZeT1w';
    this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [this.formGroup.value.lng,this.formGroup.value.lat],
        zoom: this.zoom,
    });
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(new mapboxgl.NavigationControl());

    this.map.on('click', (e:any) => {

      const {lng, lat} = e.lngLat;

      this.formGroup.patchValue({
        lat: lat,
        lng: lng,
        radius: this.formGroup.value.radius == 0 ? 500 : this.formGroup.value.radius
      });

      this.setCircle();

    });

    this.map.on('load', () => {

      this.setCircle();

    });

    // //var mapCanvas = document.getElementById('map');
    // var mapCanvas = document.querySelector("#map");
    // //console.log(mapCanvas);

    // if(this.safety_zone.lat == 0){
    //   this.center = new google.maps.LatLng(0,0);
    // }else{
    //   this.center = new google.maps.LatLng(this.safety_zone.lat,this.safety_zone.lng);
    // }
    //  // Map Options
    //  var mapOptions = {
    //      center: this.center,
    //       mapTypeId: google.maps.MapTypeId.ROADMAP,
    //      zoom: 12
    //  };

    //  this.map = new google.maps.Map(mapCanvas, mapOptions);

    // let self = this;

    // this.map.addListener('click', function(e:any) {
    //   //console.log(e.latLng);
    //   let latLng = e.latLng;
    //   self.map.panTo(latLng);

    //   if(!self.marker){
    //     self.radius = 1000;
    //     self.center = latLng;
    //     self.setCircle();
    //   }else{
    //     self.marker.setPosition(latLng);
    //     self.circle.setCenter(latLng);
    //   }

    //   var lat = self.marker.getPosition().lat();
    //   var lng = self.marker.getPosition().lng();
    //   self.formGroup.patchValue({
    //     lat: lat,
    //     lng: lng,
    //   });


    // });
    // if(this.safety_zone.lat != 0){
    //   this.setCircle();

    // }

  }

  goToLatLng(){

    this.map.flyTo({
      center: [this.formGroup.value.lng,this.formGroup.value.lat],
      zoom: 12
    });

    // let values = this.formGroup.value;
    // this.center = new google.maps.LatLng(values.lat,values.lng);
    // this.map.panTo(this.center);
    // if(!this.marker){
    //   this.radius = 1000;
    //   this.setCircle();
    // }else{
    //   this.marker.setPosition(this.center);
    //   this.circle.setCenter(this.center);
    // }
  }

  setCircle(){

    if(this.formGroup.value.radius > 0){

      var center = turf.point([this.formGroup.value.lng,this.formGroup.value.lat]);
      var options = {
        steps: 80,
        units: 'meters'
      }

      this.circle = turf.circle(center, this.formGroup.value.radius, options);

      if(this.map.getLayer('circle-fill')){
        this.map.removeLayer('circle-fill');
        this.map.removeSource('circle-fill');
      }

      this.map.addLayer({
        "id": "circle-fill",
        "type": "fill",
        "source": {
            "type": "geojson",
            "data": this.circle
        },
        "paint": {
            "fill-color": "green",
            "fill-opacity": 0.5
        },
      });

    }

    // this.marker = new google.maps.Marker({
    //   position: this.center,
    //   map: this.map
    // });

    // this.circle = new google.maps.Circle({
    //   strokeColor: '#078b00',
    //   strokeOpacity: 0.8,
    //   strokeWeight: 2,
    //   fillColor: '#078b00',
    //   fillOpacity: 0.35,
    //   map: this.map,
    //   center: this.center,
    //   radius: this.radius
    // });
  }

  changeRadius(){
    //console.log(this.radius);
    this.setCircle();
  }


  doAddWorker(){

    this.submittedWF = true;
    if(this.workerFormGroup.valid){

      let values = this.workerFormGroup.value;

      //console.log(values);

      this.okService.put("safetyzones/addworkers/"+this.safety_zone.id,values)
      .subscribe((data) => {

        this.getSafetyZone();

        this.okService.setAlert(this.transloco.translate("The worker has been added to the safety zone."), "success");
      })
    }

    return false;
  }

  doRemoveWorker(worker:any){
    if(confirm(this.transloco.translate("Are you sure you want to remove ")+worker.name+this.transloco.translate(" from this safety zone"))) {

        this.okService.put("safetyzones/removeworkers/"+this.safety_zone.id,{id:worker.id})
        .subscribe((data) => {

          this.getSafetyZone();

          this.okService.setAlert(this.transloco.translate("The worker has been removed from the safety zone."), "success");
        })

    }

  }

}
